export const PROFILE_HEADER_ACTIONS_SLOT_ID = "profile-header-actions-slot";

export const WORK_SUMMARY_TAB_LABEL = "Work Summary";
export const PROFILE_TAB_LABEL = "Profile";
